import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddSuccessPage } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddSuccessPage";

export const AddRealEstateSuccessPage = () => (
	<PortfolioAddSuccessPage namespace={Resources.Portfolio.AddRealEstate} />
);
